<template>
  <vx-card :title="$t('labels.consultant_profile')" v-if="$store.state.userInfo.type === 'CN'">
    <vs-tabs v-model="tabs">
      <vs-tab :label="$t('labels.contact_details')" class="mt-6">
        <contact-details></contact-details>
      </vs-tab>
      <vs-tab :label="$t('labels.document_details')">
        <documents></documents>
      </vs-tab>
    </vs-tabs>
  </vx-card>
  <vx-card v-else>
    <vs-tabs v-model="tabs">
      <vs-tab :label="$t('labels.contact_details')" class="mt-6">
        <contact-details></contact-details>
      </vs-tab>
      <vs-tab :label="$t('labels.document_details')">
        <documents></documents>
      </vs-tab>
    </vs-tabs>
  </vx-card>
</template>
<script>
import BasicDetails from "@/layouts/components/consultant-detail/basicDetails.vue";
import ContactDetails from "@/layouts/components/consultant-detail/contactDetails.vue";
import AddEditConsultant from "@/layouts/components/users/addedit-consultant.vue";
import Documents from "@/views/documents/list.vue";

export default {
  data() {
    return {
      tabs: this.$store.state.tabs
    };
  },
  components: {
    BasicDetails,
    ContactDetails,
    Documents,
    AddEditConsultant
  }
};
</script>
<style scoped>
button.login-btn {
  background: rgba(var(--vs-primary), 1) !important;
}

.vs-button-primary.vs-button-filled:hover {
  box-shadow: 0 8px 25px -8px rgba(var(--vs-primary), 1);
}
</style>



